import React from 'react';
import classNames from 'classnames';

export default function InfoIcon({ className = '' }) {
	return <span className={classNames('icon icon-information', className)} />;
}
